import React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import {Card} from "@heroui/react";
import {TruckIcon} from "lucide-react";
import Loading from '../../components/loading';
import { useNavigate } from "react-router-dom";

const containerStyle = {
    width: '100%',
    height: '500px',
};

const defaultCenter = {
    lat: 48.8566, // Coordonnées de Paris par défaut
    lng: 2.3522,
};

// Données factices de livraisons
const fakeDeliveries = [
    { id: 1, lat: 48.8566, lng: 2.3522, address: "Paris, France" },
    { id: 2, lat: 51.5074, lng: -0.1278, address: "London, UK" },
    { id: 3, lat: 40.7128, lng: -74.0060, address: "New York, USA" },
    { id: 4, lat: 34.0522, lng: -118.2437, address: "Los Angeles, USA" },
];

const DeliveryMap = ({deliveries}) => {
    
    const navigate = useNavigate();
    
    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY, // Remplacez par votre clé API
    });

    if (loadError) return <div>Erreur lors du chargement de la carte</div>;
    if (!isLoaded) return <div>Chargement de la carte...</div>;


    return (
        <Card shadow={'sm'} className='dark:bg-zinc-900'>
            <div className={"flex justify-between item-center px-5 py-3"}>
                <h3 className="text-lg font-semibold">Livraison en attente</h3>
                <TruckIcon size={20} className="text-gray-500 dark:text-gray-100" />
            </div>
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={defaultCenter}
                zoom={10}
            >
                {deliveries.map((delivery) => (
                    <Marker
                        key={delivery.id}
                        position={{ lat: delivery.address.latitude, lng: delivery.address.longitude }}
                        title={delivery.address.street + ' ' + delivery.address.street_number}
                        onClick={() =>navigate(`/dashboard/delivery/${delivery.id}`)}
                    />
                ))}
            </GoogleMap>
        </Card>
    );
};

export default React.memo(DeliveryMap);
